import { useMemo } from 'react';
import StyledSelect from './StyledSelect';
import { ODDS_FORMAT_OPTIONS } from '../../../../constants/odds';
import useLocalization from '../../../../hooks/useLocalization';
import { useUpdateUserData, useUserData } from '../../../../queries';
import { SelectChangeEvent } from '@mui/material';
import { OddsFormat } from '../../../../types/enums';
import { useAuth } from '@neotech-solutions-org/neofusion-fe-shared';

const SelectFormat = () => {
  const { isAuthenticated } = useAuth();
  const { getLocalizedConfig } = useLocalization();
  const { data: userSettings } = useUserData();
  const localizedOddsFormat = useMemo(() => getLocalizedConfig(ODDS_FORMAT_OPTIONS), [getLocalizedConfig]);
  const { mutate: updateUserSettings } = useUpdateUserData();

  if (!isAuthenticated) return null;

  const handleChangeFormat = (event: SelectChangeEvent) => {
    const selectedFormat = event.target.value as OddsFormat;
    updateUserSettings({
      sportsbookConfig: {
        ...(userSettings?.sportsbookConfig || {}),
        oddsFormat: selectedFormat,
      },
    });
  };

  return (
    <StyledSelect
      value={userSettings?.sportsbookConfig?.oddsFormat || ''}
      itemsList={localizedOddsFormat}
      handleChange={handleChangeFormat}
    />
  );
};

export default SelectFormat;
